import React from 'react'
import { Link } from 'react-router-dom'


const Home = () => {
  return (
    <div >

    <main className="home">
  <h2>Hi! My Name Is</h2>
  <h1 className="home__name">
    Harry <span className="home__name--last">Potter</span>
  </h1>
  <h2></h2>
</main>

  </div>
  )
}

export default Home